import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae6a33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tmc-list" }
const _hoisted_2 = { class: "flex itemscenter justify-between mt-6" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_write_offs_filters = _resolveComponent("write-offs-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Списания" }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.havePermissions(['write-offs-store', 'all-root-permission']))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/tmc/write-offs/create"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, {
                  loading: _ctx.state.writeoffs.is_loading,
                  class: "primary small",
                  hint: "Добавить списание"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "primary small ml-2",
          onClick: _ctx.exportExcel,
          loading: _ctx.state.writeoffs.is_loading,
          hint: "Скачать в Excel"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _createVNode(_component_write_offs_filters, {
      class: "mt-6",
      loading: _ctx.state.writeoffs.is_loading,
      onSubmit: _ctx.onSubmitFilters,
      onReset: _ctx.onResetFilters
    }, null, 8, ["loading", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.writeoffs.is_failed && !_ctx.state.writeoffs.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.writeoffs.is_loading,
            text: "При получении списка списаний произошла ошибка",
            "error-message": _ctx.state.writeoffs.failure.error_state.message,
            "error-url": _ctx.state.writeoffs.failure.error_state.url,
            "error-status": _ctx.state.writeoffs.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadWriteoffs(_ctx.state.writeoffs.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.writeoffs.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.writeoffs.is_loading,
                columns: _ctx.WriteOffsColumns,
                rows: _ctx.state.writeoffs.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.writeoffs.pagination.total_items,
                "pagination-current-page": _ctx.state.writeoffs.pagination.current_page,
                "pagination-total-pages": _ctx.state.writeoffs.pagination.total_pages,
                "is-columns-modal": "",
                onChangePage: _ctx.loadWriteoffs,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'id')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/tmc/write-offs/${row.id}`,
                        class: "tmc-list__link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'writeOffItems')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (row[column.key].length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row[column.key], (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, _toDisplayString(_ctx.cutName(item.inventoryItemName)) + " (" + _toDisplayString(item.amount) + ") ", 1))
                              }), 128))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" - ")
                              ], 64))
                        ], 64))
                      : (column.key === 'payerCompanyName' && row.invoice)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row.invoice.payerCompanyName || '-'), 1)
                          ], 64))
                        : (column.key === 'createdAt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                            ], 64))
                          : (
                                column.key === 'status' && row.status && row.status.statusName
                            )
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 4,
                                class: _normalizeClass(["small", {
                                    primary: row.status.statusId === 1,
                                    red: row.status.statusId === 2,
                                }])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.status.statusName), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                              ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  (_ctx.havePermissions(['write-offs-store', 'all-root-permission']))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/tmc/write-offs/${row.id}/update`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_the_button, {
                            hint: "Редактировать",
                            class: "yellow extra-small"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}